import { createColDefs } from '@fortem-monorepo/react-ag'
import { valueFormatterFromMap } from '@fortem-monorepo/react-ag'
import { useUserContext } from '@fortem-monorepo/react-spa'

import { audit } from '@/ag-grid/columns/audit/col-def'
import { client_id } from '@/ag-grid/columns/client-id/col-def'
import { counterparty_id } from '@/ag-grid/columns/counterparty-id/col-def'
import { currency_id } from '@/ag-grid/columns/currency-id/col-def'
import { strategy_id } from '@/ag-grid/columns/strategy-id/col-def'
import { trade_type } from '@/ag-grid/columns/trade-type/coldef'
import { trader_id } from '@/ag-grid/columns/trader-id/col-def'
import {
  active,
  comment,
  instrument_type,
  notional,
  price,
  quantity,
  settlement_date,
  trade_date,
  trade_datetime_utc,
  unique_identifier,
} from '@/pages/trading/booked-trades/grids/shared-coldefs'
import { useTradingData } from '@/react-query/queries/static'

export const createBespokeColDefs = ({
  ctx,
  tradeData,
}: {
  ctx: ReturnType<typeof useUserContext>
  tradeData: ReturnType<typeof useTradingData>
}) => {
  const canEdit = ctx.hasPermissions((permissions) => ({ permissions: [permissions.WRITE_TRADES] }))

  return createColDefs([
    audit,
    trade_date,
    {
      ...strategy_id,
      editable: canEdit,
      filterParams: {
        valueFormatter: valueFormatterFromMap(tradeData.maps.strategies),
      },
    },
    {
      field: 'strategy_name',
      headerName: 'Strategy Name',
      hide: true,
    },
    {
      ...active,
      width: 90,
    },
    unique_identifier,
    {
      field: 'reference_instrument_unique_identifier',
      headerName: 'Ref Instrument',
      width: 150,
    },
    instrument_type,
    {
      ...trade_type,
    },
    {
      field: 'trade_id',
      headerName: 'Trade Id',
      width: 280,
    },
    {
      ...price,
      editable: canEdit,
    },
    {
      ...quantity,
      editable: canEdit,
    },
    {
      field: 'trade_side',
      headerName: 'Trade Side',
    },
    notional,
    {
      ...currency_id,
      editable: canEdit,
      filterParams: {
        valueFormatter: valueFormatterFromMap(tradeData.maps.currencies),
      },
    },
    {
      field: 'trade_currency',
      headerName: 'Trade Ccy',
      hide: true,
    },
    {
      field: 'inst_currency',
      headerName: 'Inst Ccy',
      cellClass: 'text-center',
      width: 115,
    },
    {
      ...trade_datetime_utc,
      editable: canEdit,
      width: 150,
    },
    {
      ...settlement_date,
      editable: canEdit,
    },
    {
      ...counterparty_id,
      editable: canEdit,
      filterParams: {
        valueFormatter: valueFormatterFromMap(tradeData.maps.counterparties),
      },
    },
    {
      field: 'counterparty_name',
      headerName: 'Counterparty Name',
      hide: true,
    },
    {
      ...client_id,
      editable: canEdit,
      width: 250,
      filterParams: {
        valueFormatter: valueFormatterFromMap(tradeData.maps.clients),
      },
    },
    {
      field: 'client_name',
      headerName: 'Client Name',
      hide: true,
    },
    {
      ...trader_id,
      editable: canEdit,
      filterParams: {
        valueFormatter: valueFormatterFromMap(tradeData.maps.traders),
      },
    },
    {
      field: 'trader_name',
      headerName: 'Trader Name',
      hide: true,
    },
    {
      ...comment,
      editable: canEdit,
    },
    {
      field: 'applied_fee_bps',
      headerName: 'Applied Feed (bps)',
      width: 160,
      editable: canEdit,
    },
    {
      field: 'cost_and_charges_bps',
      headerName: 'Cost & Charges (bps)',
      width: 170,
      editable: canEdit,
    },
    {
      field: 'chargeable_pnl',
      headerName: 'Chargeable PnL',
      width: 150,
      editable: canEdit,
    },
    {
      ...currency_id,
      field: 'chargeable_pnl_currency_id',
      headerName: 'Chargeable PnL Ccy',
      width: 175,
      editable: canEdit,
      filterParams: {
        valueFormatter: valueFormatterFromMap(tradeData.maps.currencies),
      },
    },
    {
      field: 'chargeable_pnl_fx_rate',
      width: 200,
      headerName: 'Chargeable PnL Fx Rate',
      editable: canEdit,
    },
    {
      field: 'trade_source',
      headerName: 'Source',
      width: 100,
    },
    {
      field: 'executed_via_fix',
      width: 150,
    },
    {
      field: 'note',
      editable: canEdit,
    },
    {
      field: 'top_level_bucket',
      headerName: 'Top Level Bucket Name',
      hide: true,
    },
    {
      field: 'investment_bucket',
      headerName: 'Investment Bucket Name',
      hide: true,
    },
    {
      field: 'wrapper_bucket',
      headerName: 'Wrapper Bucket Name',
      hide: true,
    },
  ])
}
